import type { CalendarLocale } from "../types/types";

export const fr: CalendarLocale = {
  weekdays: {
    shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
    longhand: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
  },
  months: {
    shorthand: [
      "janv.",
      "févr.",
      "mars",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc.",
    ],
    longhand: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ],
  },
  localeTag: "fr",
  rangeDurationOne: "1 jour",
  rangeDurationOther: "{n} jours",
  inputPlaceholder: "Choisir une date",
  rangeInputPlaceholder: "Choisir une plage de dates",
  rangeCancel: "Annuler",
  rangeApply: "Appliquer",
};
